import { apiClient } from "../config";

async function getAllForms(queryParams: any) {
  const res = await apiClient.get(`/admin/dynamic-forms`, {
    params: queryParams,
  })
  return res.data;
}

export default getAllForms;
